import { f as l } from "./FormErrorMessage-N01qoSro-Bn5Q2CZe.js";
import { memo as r } from "react";
const o = ({
  title: e,
  titleId: i,
  ...t
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": i,
    ...t,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: i, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M776.851 695.153c16.64 16.619 16.64 43.733 0 60.373-8.32 8.32-19.179 12.587-30.08 12.587-10.88 0-21.952-4.267-30.293-12.587L522.771 561.819l-193.92 193.707c-8.32 8.32-19.179 12.587-30.08 12.587-10.88 0-21.952-4.267-30.293-12.587-16.64-16.64-16.64-43.755 0-60.373l193.941-193.707-193.941-193.92c-16.64-16.64-16.64-43.733 0-60.373s43.733-16.64 60.373 0l193.92 193.92 193.707-193.92c16.64-16.64 43.733-16.64 60.373 0s16.64 43.733 0 60.373l-193.707 193.92z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(o);
export {
  m as t
};
